import { useQuery } from "@tanstack/react-query";
import { getAllSeniority } from "../../../api/users/getAllSeniority";

export const useGetAllSeniority = () => {

  return useQuery({
    queryKey: ["getAllSeniority"],
    queryFn: getAllSeniority,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};
